<script>
  const goHome = () => {
    window.location.hash = '#/';
  };
</script>

<div class="notfound">
  <h1>Page not found</h1>
  <p>The page you’re looking for doesn’t exist.</p>
  <button on:click={goHome}>Go to Home</button>
  <a href="#/" class="link">Back to Video Universe</a>
  <small>Error 404</small>
</div>

<style>
  .notfound {
    position: fixed;
    inset: 0;
    display: grid;
    place-items: center;
    background: radial-gradient(1200px 800px at 50% 40%, rgba(255,62,0,0.15), transparent) , linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    color: #fff;
    text-align: center;
    padding: 2rem;
  }
  h1 { margin: 0 0 0.5rem 0; }
  p { margin: 0 0 1rem 0; opacity: 0.9; }
  button {
    background: #ff3e00;
    color: #fff;
    border: none;
    padding: 0.6rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    margin-right: 10px;
  }
  .link { color: #fff; opacity: 0.9; }
  small { display: block; margin-top: 1rem; opacity: 0.7; }
</style>

